module.exports = __webpack_public_path__ + "img/reset_light_step_1.dc3d0a39.png";